import {Component,OnInit,ViewChild} from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';
import {ModalDirective} from 'ngx-bootstrap';
import {Principal,StateStorageService} from 'src/app/core';
import {MessageConst} from 'src/app/shared/constants/message.constants';
import {ISubRuleMySuffix} from 'src/app/shared/model/subrule-my-suffix.model';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';

declare var $:any;

@Component({
    selector: 'jhi-sub-rule-my-suffix-detail',
    templateUrl: './sub-rule-my-suffix-detail.component.html'
})
export class SubRuleMySuffixDetailComponent implements OnInit {
    _subRule: ISubRuleMySuffix;
    ruleId: number;

    @ViewChild('viewMoreModal') viewMoreModal: ModalDirective;

    isShowPastHistory: boolean;
  isOpenRequest = false;
    policyMarketType: any;
    constructor(
        private activatedRoute: ActivatedRoute,
        private principal: Principal,
        private router: Router,
        private languageChangeService: LanguageChangeService,
        private stateStorageService:StateStorageService
        
    ) { 
        this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                  window.history.back();
                this.languageChangeService.refreshLanguage();
            }
    });
    }

    summaryDetailsUrl: string = '';
    otsKeyword: string = '';
    isOts: boolean = false;
    scopeId: string = '';
    randomOtsId=null;

    ngOnInit() {

        const CURRENT_URL: string = this.router.url;
        this.isOts = CURRENT_URL.includes('ots');
        const isSummaryDetailsUrl: string = localStorage.getItem(MessageConst.CURRENT_URL_SUMMARY_PAGE);
        if(this.isOts && isSummaryDetailsUrl) {
            this.summaryDetailsUrl = JSON.parse(isSummaryDetailsUrl);
            this.otsKeyword = 'ots';
        }
        
        this.randomOtsId = this.activatedRoute.snapshot.queryParams[ "ranOtsId" ];
        
        if(this.randomOtsId!=null && this.stateStorageService.contains(this.randomOtsId)) {
            this.summaryDetailsUrl=this.stateStorageService.getCurrentSummaryPageUrl(this.randomOtsId);
            this.isOts=true;
            this.otsKeyword = 'ots';
        }

        this.scopeId = this.activatedRoute.snapshot.params['scopeId'];
        this.isShowPastHistory = this.principal.isShowPastHistory;
        this.ruleId = this.activatedRoute.snapshot.params['ruleId'];
        this.policyMarketType = this.activatedRoute.snapshot.params['policyMarketType'];
        this.checkPremiumCalculationPermission();
        this.activatedRoute.data.subscribe(res => {
            console.log(res);
           if(res.pageTitle == "open-Sub-Rule"){
            this.isOpenRequest = true;
           }
            this.subRule = res.subrule.body;
        }); 
    }

    get subRule() {
        return this._subRule;
    }

    set subRule(subRule: ISubRuleMySuffix) {
        this._subRule = subRule;
    }

    previousState() {
        window.history.back();
    }

    get authority() {
        return this.principal.userIdentity.authorities[0];
    }

    viewHistoryRule(subRule) {
        this.parentHistoryToggle = true;
        this.historyTitle = 'Sub Rule History';
        this.historyType = "SUB_RULE_AUDIT";
        this.historyId = subRule.id;
       // $('.dropdown.show .dropdown-toggle').dropdown('toggle');

    }

    // history
    historyData = [];
    historyTitle: string;
    historyType: string;
    historyId: number;

    parentHistoryToggle = false;
    parentFutureHistoryToggle = false;

    receiveToggleEvent($event) {
        this.parentHistoryToggle = $event;
        this.parentFutureHistoryToggle = $event;
    }

    hideFutureHistorySidebar() {
        if (document.getElementById("future-history-window")) {
            this.parentHistoryToggle = false;
            this.parentFutureHistoryToggle = false;
        }
    }
    isPremiumCalculationDisable:boolean;
    checkPremiumCalculationPermission(){
        this.principal.checkPremiumCalculationAccessForUser().then(res =>{
            if(res){
                console.log("checkPremiumCalculationPermission if" , res);
                this.isPremiumCalculationDisable= false;
            }else{
                console.log("checkPremiumCalculationPermission else" , res);
                this.isPremiumCalculationDisable= true;
            }
        });
    }

    dataText="";
    viewMoreData: any[]=[];
    showViewMoreModal(data,dataText) {
        
        this.viewMoreData = data;
        this.viewMoreModal.show();
        this.dataText=dataText;

    }

    hideViewMoreModal() {
        this.viewMoreModal.hide();
        this.viewMoreData=[];
        this.dataText=""
    }
       

}
